import React, { useState } from 'react';
import cx from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Input from '../../../../../common/components/Input/Input';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import './InputWithClipboard.pcss';

import clipboardIcon from './clipboard.svg';

type Props = {
  className?: string;
  value?: string;
  title: string;
  helperText?: string;
  isCopyDisabled?: boolean;
  onFocus?: () => void;
};

export const InputWithClipboard = ({
  className,
  title,
  helperText,
  isCopyDisabled,
  value,
  onFocus,
}: Props) => {
  const [inputRef, setInputRef] = useState<HTMLInputElement | undefined>(
    undefined,
  );

  const selectText = () => {
    if (inputRef) {
      inputRef.setSelectionRange(0, inputRef.value.length);
    }
    if (onFocus) {
      onFocus();
    }
  };

  const [copyActionCompleted, setCopyActionCompleted] = useState(false);

  return (
    <div className={cx(className)}>
      <div className="input-with-clipboard__title">
        {title}
        {copyActionCompleted && (
          <span className="input-with-clipboard__success—text">
            <i className="fas fa-check" /> Copied!
          </span>
        )}
      </div>
      <div className="input-with-clipboard__field">
        <div className="input-with-clipboard__field-row">
          <Input
            inputRef={setInputRef}
            className="input-with-clipboard__input"
            readOnly="readonly"
            value={value}
            onFocus={selectText}
          />
          <CopyToClipboard
            text={value}
            onCopy={() => setCopyActionCompleted(true)}
          >
            <Button link disabled={isCopyDisabled}>
              <div className="input-with-clipboard__copy-icon">
                <img src={clipboardIcon} alt="Clipboard icon" />
              </div>
              Copy to clipboard
            </Button>
          </CopyToClipboard>
        </div>
        <div className="input-with-clipboard__helper-text">{helperText}</div>
      </div>
    </div>
  );
};
